module.exports = __webpack_public_path__ + "media/images/admin/node_builder_img/icons/validationnode-9e4cdb1c28b3bff68af6cd1520a39af5.svg";